import React from "react";
import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import About from "../components/About/About";
import Stats from "../components/Stats/Stats";
import Main from "../components/Main/Main";
import Clients from "../components/Clients/Clients";
import Testimonials from "../components/Testimonials/Testimonials";
import Insights from "../components/Insights/Insights";
import Footer from "../components/Footer/Footer";



const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Stats />
      <Main />
      <Clients />
      <Testimonials />
      <Insights />
      <Footer />

    </>
  );
};

export default HomePage;
